import React from "react";

const ProFeatures = ({ page }) => {
    return (
        <div className="bg-white shadow rounded-xl p-6">
            <h1 className="text-2xl font-bold text-gray-800 mb-4">Pro Features</h1>
            <p className="text-gray-600">Access premium features and functionality for advanced users.</p>
            
            <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="border border-gray-200 rounded-xl p-4">
                    <h2 className="text-xl font-semibold text-gray-800 mb-2">All Popups</h2>
                    <p className="text-gray-600 mb-4">Create and manage popup notifications for your legal pages.</p>
                    <a href="#/pro-features/all-popups" className="text-blue-600 hover:text-blue-800 font-medium">
                        Manage Popups →
                    </a>
                </div>
                
                <div className="border border-gray-200 rounded-xl p-4">
                    <h2 className="text-xl font-semibold text-gray-800 mb-2">Cookie Bar</h2>
                    <p className="text-gray-600 mb-4">Display cookie consent bars to comply with privacy regulations.</p>
                    <a href="#/pro-features/cookie-bar" className="text-blue-600 hover:text-blue-800 font-medium">
                        Configure Cookie Bar →
                    </a>
                </div>
            </div>
        </div>
    );
};

export default ProFeatures;